import { EssentialTypesMapping } from 'api/client/mapping/essential-types-mapping';
import { HelpersMapping } from 'api/client/mapping/helpers-mapping';
import { DeviationRequestsListApi, DeviationRequestsQueryFilter, DeviationRequestsQueryRecord, DeviationRequestsQueryType } from 'api/deviation-requests-list';
import { DeviationRequestListQueryDTO, DeviationRequestsClient } from 'api/swagger/ApiClient';
import { autoinject } from "aurelia-framework";
import { SystemError } from "framework/error_handling/system-error";
import { FileResponse, QueryParams } from 'model/essential-types';

@autoinject
export class DeviationRequestsListClientApi implements DeviationRequestsListApi {
  constructor(private deviationRequestsClient: DeviationRequestsClient, private helpersMapping: HelpersMapping, private essentialTypesMapping: EssentialTypesMapping) {
  }


  async queryDeviationRequests(type: DeviationRequestsQueryType, filter: DeviationRequestsQueryFilter, params: QueryParams): Promise<DeviationRequestsQueryRecord[]> {
    switch (type) {
      case DeviationRequestsQueryType.User: {
        return (await this.deviationRequestsClient.getForCurrentUser(params.skip, params.take, params.sortExpression, filter.from, filter.to, filter.statusValue, filter.deviationType, filter.workflowType, filter.detailType, filter.text, this.helpersMapping.mapToApiIsActiveFilter(filter.includeArchived)))
          .data.map(x => this.mapDeviationRequestsQueryRecord(x));
      }
      case DeviationRequestsQueryType.EntityWide: {
        return (await this.deviationRequestsClient.getEntityWides(params.skip, params.take, params.sortExpression, filter.from, filter.to, filter.statusValue, filter.deviationType, filter.workflowType, filter.detailType, filter.text, this.helpersMapping.mapToApiIsActiveFilter(filter.includeArchived)))
          .data.map(x => this.mapDeviationRequestsQueryRecord(x));
      }
      case DeviationRequestsQueryType.ForReview: {
        return (await this.deviationRequestsClient.getForReview(params.skip, params.take, params.sortExpression, filter.from, filter.to, filter.statusValue, filter.deviationType, filter.workflowType, filter.detailType, filter.text, this.helpersMapping.mapToApiIsActiveFilter(filter.includeArchived)))
          .data.map(x => this.mapDeviationRequestsQueryRecord(x));
      }
      case DeviationRequestsQueryType.Reviewed: {
        return (await this.deviationRequestsClient.getReviewed(params.skip, params.take, params.sortExpression, filter.from, filter.to, filter.statusValue, filter.deviationType, filter.workflowType, filter.detailType, filter.text, this.helpersMapping.mapToApiIsActiveFilter(filter.includeArchived)))
          .data.map(x => this.mapDeviationRequestsQueryRecord(x));
      }
      case DeviationRequestsQueryType.All: {
        return (await this.deviationRequestsClient.getAll(params.skip, params.take, params.sortExpression, filter.from, filter.to, filter.statusValue, filter.deviationType, filter.workflowType, filter.detailType, filter.text, this.helpersMapping.mapToApiIsActiveFilter(filter.includeArchived)))
          .data.map(x => this.mapDeviationRequestsQueryRecord(x));
      }
      default:
        throw new SystemError(`Deviation Request Query type ${type} is not supported`, "Not supported");
    }
  }

  downloadDeviationRequests(type: DeviationRequestsQueryType, filter: DeviationRequestsQueryFilter, params: QueryParams): Promise<FileResponse> {
    switch (type) {
      case DeviationRequestsQueryType.EntityWide: {
        return this.deviationRequestsClient.getEntityWidesReport(params.sortExpression, filter.from, filter.to, filter.statusValue, filter.deviationType, filter.workflowType, filter.detailType, filter.text, this.helpersMapping.mapToApiIsActiveFilter(filter.includeArchived));
      }
      default:
        throw new SystemError(`Deviation Requests Download type ${type} is not supported`, "Not supported");
    }
  }

  private mapDeviationRequestsQueryRecord(dto: DeviationRequestListQueryDTO): DeviationRequestsQueryRecord {
    return {
      id: dto.id,
      typeInfo: dto.typeInfo,
      requestedBy: this.essentialTypesMapping.mapPersonInfoToPersonInfo(dto.requestedBy),
      assignedTo: dto.assignedTo !== null ? this.essentialTypesMapping.mapPersonInfoToPersonInfo(dto.assignedTo) : null,
      deviationType: dto.deviationType,
      workflowType: dto.workflowType,
      detailType: dto.detailType,
      from: dto.validFrom,
      to: dto.validTo,
      status: dto.status,
      statusChangedOn: dto.statusChangedOn,
      statusChangedBy: this.essentialTypesMapping.mapPersonInfoToPersonInfo(dto.statusChangedBy),
      detailInfo: dto.detailInfo,
      detailAdditionalInfo: dto.detailAdditionalInfo,
      travelers: dto.travellers.map(t => this.essentialTypesMapping.mapPersonInfoToPersonInfo(t)),
      isActive: dto.isActive
    }
  }
}
